import React, { useCallback, useEffect, useRef, useState } from "react"

import DesktopTable from "./components/DesktopTable"
import MobileTable from "./components/MobileTable"
import {
  Wrapper,
  Title,
  Subtitle,
  PackageTableWrapper,
} from "./styles/PackageTableBuilder.styled"

const PackageTableBuilder = ({ component }) => {
  const { packageTableTitle, packageTableSubtitle } = component

  const [isTableNavSticky, setIsTableNavSticky] = useState(false)
  const tableRef = useRef(null)

  const menuHeight = 146

  const handleNavSticky = useCallback(
    ({ top, bottom }) => {
      if (top <= menuHeight && bottom >= menuHeight * 2) {
        !isTableNavSticky && setIsTableNavSticky(true)
      } else {
        isTableNavSticky && setIsTableNavSticky(false)
      }
    },
    [isTableNavSticky]
  )

  useEffect(() => {
    const handleScroll = () => {
      handleNavSticky(tableRef.current.getBoundingClientRect())
    }
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [tableRef, isTableNavSticky])

  return (
    <Wrapper>
      {packageTableTitle && <Title>{packageTableTitle}</Title>}
      {packageTableSubtitle && <Subtitle>{packageTableSubtitle}</Subtitle>}
      <PackageTableWrapper ref={tableRef}>
        <DesktopTable
          component={component}
          isTableNavSticky={isTableNavSticky}
        />
        <MobileTable
          component={component}
          isTableNavSticky={isTableNavSticky}
        />
      </PackageTableWrapper>
    </Wrapper>
  )
}

export default PackageTableBuilder
